module.exports = __webpack_public_path__ + "img/botinterview.5d650ce1.svg";